module.exports = {
      id: "check-borderless-icon-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#check-borderless-icon",
      toString: function () {
        return this.url;
      }
    }